import {
    AlertOutlineIcon,
    BellIcon,
    MegaphoneIcon,
} from '@eventbrite/marmalade';

type TemplateConfig = {
    template: string;
    color: string;
    icon: React.FC;
};

export const DEFAULT_NOTIFICATION_TEMPLATE_ID = 1;

export const NOTIFICATION_TEMPLATES: Record<number, TemplateConfig> = {
    1: {
        template: 'informational',
        color: '#716B7A',
        icon: BellIcon,
    },
    2: {
        template: 'promotional',
        color: '#3659E3',
        icon: MegaphoneIcon,
    },
    3: {
        template: 'critical',
        color: '#FFDE3B',
        icon: AlertOutlineIcon,
    },
};
